import { NodeType } from '@/domain/bot';

// make this more generic and applicable also to any string type (for custom modules)
export const nodeTypes: NodeType[] = [
    'Prompt',
    'OpenQuestion',
    'SMSModule',
    'YesNoConfirmation',
    'NumericRatingModule',
    'ValueRangeRouter',
    'StickerModule',
    'CustomInternalModule',
    'CalendarModule',
    'GPTModule',
    'MSearchModule',
    'MDataChatModule',
    'RestCallout',
    'TransferToAgentModule',
];
